import {
  IonButton,
  IonButtons,
  IonCol,
  IonContent,
  IonFooter,
  IonGrid,
  IonHeader,
  IonIcon,
  IonInput,
  IonItem,
  IonLabel,
  IonModal,
  IonRow,
  IonSpinner,
  IonText,
  IonTextarea,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import {
  checkmarkDoneCircleOutline,
  chevronBack,
  informationCircleOutline,
  returnUpBackOutline,
  warningOutline,
} from "ionicons/icons";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { fetchDocumentHistory as documentShowHistory } from "../../../store/documentShow/actions/fetchDocumentHistory";
import { findSigners as documentShowSigners } from "../../../store/documentShow/actions/findSigners";
import { setRequestCorrectionActionStatus } from "../../../store/documentSignerShow";
import { fetchDocumentHistory } from "../../../store/documentSignerShow/actions/fetchDocumentHistory";
import { findSigners } from "../../../store/documentSignerShow/actions/findSigners";
import { requestCorrection } from "../../../store/documentSignerShow/actions/requestCorrection";
import { selectCanSign } from "../../../store/documentSignerShow/selectors/selectCanSign";
import { selectRequestCorrectionStatus } from "../../../store/documentSignerShow/selectors/selectRequestCorrectionStatus";

export const DocumentCorrectionRequestButton: React.FC = () => {
  const dispatch = useDispatch();
  const requestCorrectionActionStatus = useSelector(selectRequestCorrectionStatus);
  const canSign = useSelector(selectCanSign);
  const [showModal, setShowModal] = useState(false);
  const [comment, setComment] = useState("");

  const { id }: { id: string } = useParams();

  const handleDismiss = async () => {
    await dispatch(findSigners(id));
    await dispatch(fetchDocumentHistory(id));

    dispatch(documentShowSigners(id));
    dispatch(documentShowHistory(id));
    setShowModal(false);
    dispatch(setRequestCorrectionActionStatus());
  };
  return (
    <>
      {canSign && (
        <IonButton fill="solid" onClick={() => setShowModal(true)} color="danger">
          <IonIcon icon={returnUpBackOutline} />
          <IonText class="ion-padding-start">Enviar a corregir</IonText>
        </IonButton>
      )}

      <IonModal isOpen={showModal} onDidDismiss={() => handleDismiss()}>
        <IonHeader translucent>
          <IonToolbar>
            <IonButtons slot="start">
              <IonButton onClick={() => setShowModal(false)}>
                <IonIcon icon={chevronBack} />
              </IonButton>
            </IonButtons>
            <IonTitle>Solicitar corrección al documento</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <IonGrid style={{ height: "100%", width: "100%" }} class="ion-padding">
            <IonRow class="ion-align-items-baseline" style={{ height: "100%" }}>
              <IonCol size="12" class="ion-padding-top">
                {requestCorrectionActionStatus === "pending" && (
                  <>
                    <IonSpinner name="lines" />
                    <h2>Actualizando documento</h2>
                  </>
                )}

                {requestCorrectionActionStatus === "fulfilled" && (
                  <>
                    <IonIcon icon={checkmarkDoneCircleOutline} size="large" color="success" />
                    <h2>Corrección solicitada correctamente</h2>
                  </>
                )}

                {requestCorrectionActionStatus === "rejected" && (
                  <>
                    <IonIcon icon={warningOutline} size="large" color="error" />
                    <h2>Ha ocurrido un problema solicitando la corrección</h2>
                  </>
                )}

                {!requestCorrectionActionStatus && (
                  <>
                    <IonIcon icon={informationCircleOutline} size="large" color="primary" />
                    <h2>¿Hay problemas con el contenido del documento?</h2>
                    <h4>Agrega las indicaciones para corregir el documento</h4>

                    <br />

                    <IonItem class="ion-margin-top">
                      <IonLabel position="stacked">Comentario</IonLabel>

                      <IonTextarea
                        placeholder="Ingrese las indicaciones"
                        value={comment}
                        onIonChange={({ detail: { value } }) => setComment(value || "")}
                      />
                    </IonItem>
                  </>
                )}
              </IonCol>
            </IonRow>
          </IonGrid>
        </IonContent>

        <IonFooter style={{ display: "flex" }}>
          <span style={{ display: "flex", flex: 1 }}></span>
          {requestCorrectionActionStatus !== "fulfilled" && (
            <IonButton
              onClick={() => dispatch(requestCorrection(comment))}
              disabled={requestCorrectionActionStatus === "pending" || !comment}
            >
              Solicitar corrección
            </IonButton>
          )}

          {requestCorrectionActionStatus === "fulfilled" && (
            <IonButton onClick={() => setShowModal(false)}>Volver</IonButton>
          )}
        </IonFooter>
      </IonModal>
    </>
  );
};
